import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWoocommerceRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#873eff",
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M13.3 12q-.8-.1-1.4.8l-1.7 3.1v-2.8q0-1.2-1-1.2c-1 0-1 .3-1.4 1l-1.6 3v-2.7q0-1.4-1.3-1.3H3.2q-1 0-1.1 1 0 .8 1 .8H4v3.5q0 1.6 1.6 1.6c1.6 0 1.4-.4 1.8-1.3l1-2v1.7q.1 1.6 1.7 1.6c1 0 1.3-.4 1.9-1.3l2.4-4q.7-1.6-1-1.6zm4.5 0c-2 0-3.5 1.4-3.5 3.4s1.5 3.4 3.5 3.4 3.4-1.5 3.4-3.4c0-2-1.5-3.5-3.4-3.5m0 4.8q-1.2-.1-1.3-1.3.1-1.3 1.3-1.4 1.1.1 1.2 1.4t-1.2 1.3m7.4-4.8c-2 0-3.5 1.5-3.5 3.5s1.5 3.4 3.5 3.4 3.4-1.5 3.4-3.4-1.5-3.5-3.4-3.5m0 4.8q-1.3-.1-1.3-1.3 0-1.3 1.3-1.4 1.1.1 1.2 1.4t-1.2 1.3"
	})
});
export default SvgWoocommerceRegularIcon;
